(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pixlip-brand-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pixlip-brand-marquee')) {
  customElements.define('pixlip-brand-marquee', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.viewport = this.querySelector('.pxl-mq__viewport');
      this.track = this.querySelector('.pxl-mq__track');
      this.group = this.querySelector('.pxl-mq__group');
      if (!this.viewport || !this.track || !this.group) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', () => this.schedule(), { signal });
      this.mobile = matchMedia('(max-width: 699px)');
      this.mobile.addEventListener('change', () => this.schedule(), { signal });
      this.addEventListener('shopify:block:select', () => this.setAttribute('data-editor-selected', ''), { signal });
      this.addEventListener('shopify:block:deselect', () => this.removeAttribute('data-editor-selected'), { signal });
      this.observer = new ResizeObserver(() => this.schedule());
      this.observer.observe(this.viewport);
      this.schedule();
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.build());
    }
    duplicate(node) {
      const copy = node.cloneNode(true);
      copy.setAttribute('data-pxl-duplicate', '');
      copy.setAttribute('aria-hidden', 'true');
      [copy, ...copy.querySelectorAll('*')].forEach(element => {
        element.removeAttribute('id');
        [...element.attributes].filter(attribute => attribute.name.startsWith('data-shopify')).forEach(attribute => element.removeAttribute(attribute.name));
        if (element.matches('a,button,[tabindex]')) element.setAttribute('tabindex', '-1');
      });
      return copy;
    }
    build() {
      this.setAttribute('data-measuring', '');
      this.removeAttribute('data-ready');
      this.querySelectorAll('[data-pxl-duplicate]').forEach(node => node.remove());
      const originals = [...this.group.children];
      if (originals.length < 2 || this.motion.matches || (this.dataset.stackMobile === 'true' && this.mobile.matches) || !this.viewport.clientWidth) {
        this.removeAttribute('data-measuring');
        return;
      }
      const baseWidth = this.group.getBoundingClientRect().width;
      if (!baseWidth) {
        this.removeAttribute('data-measuring');
        return;
      }
      const repetitions = Math.ceil(this.viewport.clientWidth / baseWidth);
      for (let i = 1; i < repetitions; i++) originals.forEach(node => this.group.append(this.duplicate(node)));
      const distance = this.group.getBoundingClientRect().width;
      this.track.append(this.duplicate(this.group));
      this.style.setProperty('--pxl-distance', `${distance}px`);
      const speed = Math.max(10, Math.min(60, Number(this.dataset.speed) || 24));
      this.style.setProperty('--pxl-duration', `${distance / speed}s`);
      this.setAttribute('data-ready', '');
      this.removeAttribute('data-measuring');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.removeAttribute('data-ready');
      this.querySelectorAll('[data-pxl-duplicate]').forEach(node => node.remove());
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
